/*
 * Calibra — raspadinha do formulário de inscrição. v3, 2026-10-24 (anel de foco em todos os botões do formulário; v2 2026-10-20: respiro e foco no CONTINUE). Código adaptado do da RENEW (já testado lá);
 * o texto é o do copy aprovado da Calibra (CINTOS/email/COPY-fluxos-v1.md, «O formulário»), e nenhuma frase da RENEW.
 *
 * O formulário é o da Klaviyo: inscreve na lista, mostra o código único e aplica-o no checkout. Este script só põe a
 * raspadinha no primeiro passo. Passos (gerados por build/formulario.py):
 *   1 · Reveal   — bloco de texto com a classe `calibra-raspadinha` (o cartão entra aqui) e «CONTINUE →» num bloco
 *       com a classe `calibra-raspadinha-next` (vai para o passo 2, sem enviar nada).
 *   2 · Join     — o email, o consentimento por cima do botão, «JOIN AND GET MY 15%» (envia) e «Not now» (fecha).
 *   3 · Birthday — opcional: dia e mês.
 *   4 · Success  — o bloco de cupão da Klaviyo (código único, aplicado sozinho no checkout) e «BACK TO THE SHOP».
 *
 * Evento da Klaviyo usado: `klaviyoForms` de tipo `open` → monta o cartão.
 * Se o script falhar, nada se perde: o passo 1 mostra a oferta em texto e o botão para seguir fica à vista.
 * Regras do texto: a mesma oferta para todos — nunca «win», «prize», «lucky» (UE e Reino Unido).
 */
(function () {
  "use strict";

  var CFG = {
    formIds: ["RZDPuc"],                      // Calibra · Raspadinha · v4 (com SMS), criado a 2026-10-20
    anchor: ".calibra-raspadinha",               // passo 1: onde entra o cartão
    next: ".calibra-raspadinha-next",          // passo 1: o botão «CONTINUE →», escondido até se revelar
    waitMs: 2500,
    revealAt: 0.5,                             // fracção raspada a partir da qual o cartão se revela sozinho
    brush: 34,
    text: {
      hint: "Scratch to reveal our welcome offer.",
      hintDone: "There it is.",
      big: "15% off",
      small: "your first order",
      foil: "SCRATCH HERE",
      revealButton: "No scratching? Show it now",
      announce: "There it is: 15% off your first order.",
      cardLabel: "Our welcome offer"
    },
    color: { ink: "#111111", paper: "#ffffff", cream: "#f6f6f4", rose: "#6b6b68", foilA: "#9a9a96", foilB: "#d6d6d2", muted: "#6b6b68" }
  };

  var CSS = [
    ".rr{font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;color:" + CFG.color.ink + ";text-align:center;}",
    // a instrução é o título do passo; depois de raspar passa a «Unlocked.» — o momento de emoção, em grande
    // «.rr .rr-hint» e !important na margem: a reposição da Klaviyo («.kl-private-reset-css-… p{margin:0}», classe +
    // elemento) ganhava a «.rr-hint» só com classe e encostava o cartão ao título (visto na loja a 2026-10-20)
    ".rr .rr-hint{margin:0 0 14px!important;font-size:26px;line-height:1.15;font-weight:700;letter-spacing:-0.3px;color:" + CFG.color.ink + ";}",
    ".rr-card{position:relative;margin:0 auto;width:100%;max-width:320px;aspect-ratio:16/9;background:" + CFG.color.cream + ";",
    "  border:1px dashed " + CFG.color.ink + ";display:flex;align-items:center;justify-content:center;overflow:hidden;user-select:none;-webkit-user-select:none;}",
    ".rr-offer{display:flex;flex-direction:column;gap:4px;}",
    ".rr-big{font-size:40px;line-height:1;font-weight:700;letter-spacing:-0.5px;}",
    ".rr-small{font-size:13px;letter-spacing:2px;text-transform:uppercase;color:" + CFG.color.muted + ";}",
    ".rr-foil{position:absolute;inset:0;width:100%;height:100%;cursor:grab;touch-action:none;transition:opacity .45s ease;}",
    ".rr-foil.rr-gone{opacity:0;pointer-events:none;}",
    ".rr-reveal{margin:12px 0 0;padding:6px 4px;background:none;border:0;font:inherit;font-size:13px;color:" + CFG.color.ink + ";",
    "  text-decoration:underline;cursor:pointer;}",
    ".rr-reveal:focus-visible{outline:2px solid " + CFG.color.ink + ";outline-offset:3px;}",
    ".rr-reveal[hidden]{display:none;}",
    ".rr-sr{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;}",
    // o botão para seguir só aparece depois de revelar (a classe entra quando o cartão está montado)
    ".rr-armed " + CFG.next + "{display:none!important;}",
    ".rr-armed.rr-unlocked " + CFG.next + "{display:block!important;animation:rr-in .35s ease both;}",
    // O anel de foco da Klaviyo tem a cor do botão e cola-se a ele: invisível nos botões pretos (CONTINUE, JOIN, SAVE,
    // BACK TO THE SHOP; medido na loja a 2026-10-24). Regra para todos os botões do formulário: 3 px de folga mostram-no.
    CFG.formIds.map(function (id) { return "form[data-testid=\"klaviyo-form-" + id + "\"] button:focus-visible"; }).join(",") +
      "{outline:2px solid " + CFG.color.ink + "!important;outline-offset:3px!important;}",
    "@keyframes rr-in{from{opacity:0;transform:translateY(6px);}to{opacity:1;transform:none;}}",
    "@media (prefers-reduced-motion:reduce){.rr-foil{transition:none;}.rr-armed.rr-unlocked " + CFG.next + "{animation:none;}}"
  ].join("");

  var styled = false;
  function addStyle() {
    if (styled) return;
    var s = document.createElement("style");
    s.setAttribute("data-calibra", "raspadinha");
    s.textContent = CSS;
    document.head.appendChild(s);
    styled = true;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  // O cartão: a oferta por baixo, a película por cima.
  function buildCard() {
    var t = CFG.text;
    var root = el("div", "rr");
    root.setAttribute("role", "group");
    root.setAttribute("aria-label", t.cardLabel);
    var hint = el("p", "rr-hint", t.hint);
    var card = el("div", "rr-card");
    var offer = el("div", "rr-offer");
    offer.appendChild(el("span", "rr-big", t.big));
    offer.appendChild(el("span", "rr-small", t.small));
    offer.setAttribute("aria-hidden", "true");          // escondida também para leitores de ecrã, até revelar
    var foil = el("canvas", "rr-foil");
    foil.setAttribute("aria-hidden", "true");
    card.appendChild(offer);
    card.appendChild(foil);
    var btn = el("button", "rr-reveal", t.revealButton);
    btn.type = "button";
    var live = el("p", "rr-sr");
    live.setAttribute("aria-live", "polite");
    root.appendChild(hint); root.appendChild(card); root.appendChild(btn); root.appendChild(live);
    return { root: root, hint: hint, card: card, offer: offer, foil: foil, btn: btn, live: live };
  }

  function drawFoil(canvas, w, h, dpr) {
    var ctx = canvas.getContext("2d");
    canvas.width = Math.round(w * dpr);
    canvas.height = Math.round(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.globalCompositeOperation = "source-over";
    var g = ctx.createLinearGradient(0, 0, w, h);
    g.addColorStop(0, CFG.color.foilA);
    g.addColorStop(0.5, CFG.color.foilB);
    g.addColorStop(1, CFG.color.foilA);
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, w, h);
    ctx.fillStyle = "rgba(255,255,255,0.18)";          // grão fino, para parecer película e não cor lisa
    for (var i = 0; i < (w * h) / 90; i++) ctx.fillRect(Math.random() * w, Math.random() * h, 1, 1);
    ctx.fillStyle = CFG.color.paper;
    ctx.font = "700 13px 'Helvetica Neue',Helvetica,Arial,sans-serif";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    if ("letterSpacing" in ctx) ctx.letterSpacing = "3px";
    ctx.fillText(CFG.text.foil, w / 2, h / 2);
    return ctx;
  }

  function attachScratch(parts, onReveal) {
    var canvas = parts.foil, card = parts.card;
    var dpr = Math.max(1, window.devicePixelRatio || 1);
    var ctx = null, w = 0, h = 0, drawing = false, last = null, moves = 0, done = false, touched = false;

    parts.offer.style.visibility = "hidden";           // a oferta só se vê depois de a película estar pintada
    function size() {
      var r = card.getBoundingClientRect();
      if (!r.width || !r.height) return;
      if (touched && Math.round(r.width) === w && Math.round(r.height) === h) return;
      w = Math.round(r.width); h = Math.round(r.height);
      if (!touched) { ctx = drawFoil(canvas, w, h, dpr); parts.offer.style.visibility = ""; }
    }
    size();
    // O cartão pode nascer escondido (o pop-up a entrar). O ResizeObserver pinta-o quando aparece; como reserva,
    // mede-se de 100 em 100 ms até 3 s (o observador não corre com a página em segundo plano — teste de 2026-09-29).
    // Se nem assim houver tamanho, revela-se sem película.
    if (window.ResizeObserver) new ResizeObserver(function () { if (!touched) size(); }).observe(card);
    var polls = 0, poll = setInterval(function () {
      if (!ctx) size();
      if (ctx || ++polls >= 30) { clearInterval(poll); if (!ctx) reveal(); }
    }, 100);

    function point(e) {
      var r = canvas.getBoundingClientRect();
      return { x: e.clientX - r.left, y: e.clientY - r.top };
    }
    function stroke(a, b) {
      ctx.globalCompositeOperation = "destination-out";
      ctx.lineWidth = CFG.brush;
      ctx.lineCap = "round"; ctx.lineJoin = "round";
      ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y); ctx.stroke();
    }
    function cleared() {
      var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data, step = 24 * 4, clear = 0, total = 0;
      for (var i = 3; i < data.length; i += step) { total++; if (data[i] === 0) clear++; }
      return total ? clear / total : 0;
    }
    function reveal() {
      if (done) return;
      done = true;
      canvas.classList.add("rr-gone");
      setTimeout(function () { if (canvas.parentNode) canvas.parentNode.removeChild(canvas); }, 500);
      parts.offer.style.visibility = "";
      parts.offer.removeAttribute("aria-hidden");
      parts.hint.textContent = CFG.text.hintDone;
      parts.btn.hidden = true;
      parts.live.textContent = CFG.text.announce;
      if (onReveal) onReveal();
    }

    canvas.addEventListener("pointerdown", function (e) {
      if (done || !ctx) return;
      touched = true; drawing = true; last = point(e);
      // Reter o ponteiro faz o traço continuar se o dedo sair do cartão. Nalguns aparelhos a chamada falha
      // (ponteiro já largado); sem este try, o erro cortava o primeiro traço.
      try { if (canvas.setPointerCapture) canvas.setPointerCapture(e.pointerId); } catch (err) { /* segue sem reter */ }
      stroke(last, { x: last.x + 0.1, y: last.y + 0.1 });
      e.preventDefault();
    });
    canvas.addEventListener("pointermove", function (e) {
      if (!drawing || done) return;
      var p = point(e); stroke(last, p); last = p;
      if (++moves % 6 === 0 && cleared() >= CFG.revealAt) reveal();
    });
    function end() { if (drawing && !done && cleared() >= CFG.revealAt) reveal(); drawing = false; last = null; }
    canvas.addEventListener("pointerup", end);
    canvas.addEventListener("pointercancel", end);
    parts.btn.addEventListener("click", reveal);
    return reveal;
  }

  // O «container» do formulário: o antepassado que também contém o botão para seguir.
  function formRoot(host) {
    var n = host;
    while (n && n !== document.body) {
      if (n.querySelector && n.querySelector(CFG.next)) return n;
      n = n.parentNode;
    }
    return document.body;
  }

  function mount(host) {
    if (host.querySelector(".rr")) return;             // já montado (o pop-up pode reabrir)
    addStyle();
    var parts = buildCard();
    var root = formRoot(host);
    host.innerHTML = "";
    host.appendChild(parts.root);
    root.classList.add("rr-armed");                     // só agora se esconde o botão para seguir
    attachScratch(parts, function () {
      root.classList.add("rr-unlocked");
      // A Klaviyo põe a classe no próprio <button> (visto na loja a 2026-10-20), não num bloco à volta dele;
      // aceitam-se as duas formas.
      var nextEl = root.querySelector(CFG.next), clicavel = "button, a, [role=button]";
      var nextBtn = nextEl && (nextEl.matches(clicavel) ? nextEl : nextEl.querySelector(clicavel));
      if (nextBtn && nextBtn.focus) setTimeout(function () { nextBtn.focus(); }, 60);   // teclado: segue daqui
    });
  }

  function waitFor(selector, ms) {
    return new Promise(function (resolve, reject) {
      var found = document.querySelector(selector);
      if (found) return resolve(found);
      var obs = new MutationObserver(function () {
        var n = document.querySelector(selector);
        if (n) { obs.disconnect(); clearTimeout(timer); resolve(n); }
      });
      obs.observe(document.body, { childList: true, subtree: true });
      var timer = setTimeout(function () { obs.disconnect(); reject(new Error("sem bloco")); }, ms);
    });
  }

  window.addEventListener("klaviyoForms", function (e) {
    var d = (e && e.detail) || {};
    if (CFG.formIds.indexOf(d.formId) === -1) return;
    if (d.type === "open") {
      // Sem o bloco, não se faz nada: o texto de reserva e o botão para seguir ficam como a Klaviyo os mostra.
      waitFor(CFG.anchor, CFG.waitMs).then(mount, function () {});
    }
  });

  window.CalibraRaspadinha = { mount: mount, config: CFG };   // para testes
})();
